import { Link } from 'react-router-dom'
import { HomeIcon } from '@heroicons/react/24/outline'

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
          <h2 className="mt-4 text-3xl font-bold text-gray-900">
            页面未找到
          </h2>
          <p className="mt-2 text-base text-gray-500">
            抱歉，您访问的页面不存在。
          </p>
          <div className="mt-6">
            <Link
              to="/dashboard"
              className="btn-primary inline-flex items-center"
            >
              <HomeIcon className="w-5 h-5 mr-2" />
              返回首页
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}